import { isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { DATE, DATE_TIME, TIMESTAMP } from 'reporting-data/constants/property-types';
export function getFirstNonDateDimension(dimensionEditor, properties) {
  return dimensionEditor.properties.find(dimension => {
    const property = properties[dimension];
    return property && ![DATE, DATE_TIME, TIMESTAMP].includes(property.type);
  });
}
export function useIsDimensionsEditorValid(dimensionEditor, propertiesFetch) {
  if (!dimensionEditor || !isSucceeded(propertiesFetch)) {
    return false;
  }

  // It's ok if there's no date dimension, because the default date dimension is pulled
  // from the date filter
  return !!getFirstNonDateDimension(dimensionEditor, propertiesFetch.data);
}